
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import p_reg_mobile from '../../Assets/Images/p_reg_mobile.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './customDatePicker.css';
import "react-datepicker/dist/react-datepicker.css";
import { DOBPickerModal } from "../../Components/CustomWheelDatePicker/DOBPickerModal";
import { SlCalender } from "react-icons/sl";
import { useUser } from "../../Components/UserContext";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { showToast } from "../../Components/toastConfig/ToastConfig";


const UserRegister = ({ tabtoggle }) => {
    const navigate = useNavigate();
    const { setUser } = useUser();

    const [selectedDate, setSelectedDate] = useState();
    const [isLoading, setLoadingStatus] = useState(false);
    const today = new Date();
    const [errors, setErrors] = useState({})
    const [datePickerModel, setDatePickerModel] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [showPassword, setShowPassword] = useState(false);

    const [formData, setFormData] = useState({
        user_mbl: "",
        user_name: "",
        user_email: "",
        password: "",
        referral_id: "",
        user_gender: "",
        user_dob: "",
        device_token: "",
    });

    useEffect(() => {
        let check = localStorage.getItem("login");
        if (check == "logged") {
            navigate('/');
        }
        if (check == "Register") {
            navigate(-3);
        }
    }, [])

    const sevenYearsAgo = new Date();
    sevenYearsAgo.setFullYear(today.getFullYear() - 7);

    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|co|in)$/;


    // const handleChange = (event) => {
    //     const { name, value } = event.target;
    //     let updatedValue = value;

    //     if (name === 'referral_id') {
    //         updatedValue = updatedValue.replace(/[^a-zA-Z0-9]/g, '');
    //     }

    //     if (name === 'user_email') {
    //         updatedValue = updatedValue.toLowerCase();
    //         if (!emailRegex.test(updatedValue)) {
    //             console.log("Invalid email. Please enter a correct one ending with .com, .co, or .in");

    //         }
    //     }

    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         [name]: updatedValue,
    //     }));
    // };

    // const handleCalenderChange = () => { 
    //     setSelectedDate(date);
    //     handleChange({ target: { name: 'user_dob', value: date } });
    // };


    const handleChange = (event) => {
        const { name, value } = event.target;
        let updatedValue = value;
        setErrors([])
        if (name === "referral_id") {
            updatedValue = updatedValue.replace(/[^a-zA-Z0-9]/g, "");
        }

        if (name === "user_email") {
            updatedValue = updatedValue.toLowerCase();
        }

        if (name === "user_mbl") {
            updatedValue = updatedValue.replace(/\D/g, "");

            if (updatedValue.length > 10) updatedValue = updatedValue.slice(0, 10);

            if (updatedValue && !/^[6-9]/.test(updatedValue)) return;
        }

        if (name === "password") {
            if (updatedValue.length > 20) return;

            let error = "";

            if (updatedValue.length > 0 && updatedValue.length < 8) {
                error = "Minimum 8 characters";
            } else if (!/[A-Z]/.test(updatedValue)) {
                error = "Must contain uppercase";
            } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(updatedValue)) {
                error = "Must contain special character";
            }

            setErrors(prev => ({
                ...prev,
                password: error
            }));
        }

        setFormData(prev => ({
            ...prev,
            [name]: updatedValue,
        }));
    };



    const handleSubmit = (event) => {
        event.preventDefault();

        let newErrors = {};

        if (!formData.user_name) {
            newErrors.user_name = "User name is required";
        }
        else if (!formData.user_mbl) {
            newErrors.user_mbl = "Phone number is required";
        }
        else if (!formData.user_email) {
            newErrors.user_email = "Email is required";
        }
        else if (!emailRegex.test(formData.user_email)) {
            newErrors.user_email = "Please enter valid email";
        }
        else if (!formData.password) {
            newErrors.password = "Password is required";
        }
        else if (!formData.user_gender) {
            newErrors.user_gender = "Gender is required";
        }
        else if (!formData.user_dob) {
            newErrors.user_dob = "Date of birth is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoadingStatus(true);

        // The whole profile goes up front. The server stores it against the
        // pending account, so a signup abandoned before email verification can
        // be resumed instead of leaving an account nobody can reach.
        let reqData = {
            "email": formData?.user_email,
            "phoneNumber": formData?.user_mbl,
            "user_name": formData?.user_name,
            "password": formData?.password,
            "user_gender": formData?.user_gender,
            "user_dob": formData?.user_dob,
        }


        NodeaxiosInstance.post('auth/signup-email-phone', reqData)
            .then((res) => {
                // No token is issued until the mobile OTP is verified.
                setUser(formData);
                navigate('/otpVerification', { state: { mobileNumber: formData?.user_mbl } })
            })
            .catch((error) => {
                setLoadingStatus(false);
                const code = error?.response?.data?.code;
                const message = error?.response?.data?.message || error?.message ||
                    "Something went wrong";

                if (code === "ALREADY_REGISTERED") {
                    showToast("This mobile number is already registered. Please login.");
                    tabtoggle("Login");
                    return;
                }

                showToast(message);

            });


    }



    const handleDateSelect = (formattedDate, dateObject) => {
        handleChange({ target: { name: 'user_dob', value: dateObject } });
        setSelectedDate(dateObject);
        setDatePickerModel(false);
    };

    const checkBtnDisable = () => {
        if (!formData.user_name || !formData.user_mbl || !formData.user_email || !formData.password || !formData.user_gender || !formData.user_dob) {
            return true;
        }
        if (errors.password) {
            return true;
        }
        return false;
    }

    return (
        <>
            <form className="form bg-white" onSubmit={handleSubmit}>
                <div className='ff-poppins-regular fs-12'>User Name <span className="text-danger">*</span></div>
                <input type="text" className="w-100 ff-poppins-medium fs-20" maxLength={25} name="user_name" value={formData.user_name} onChange={handleChange} />

                {errors.user_name && (
                    <div className="text-danger ff-poppins-medium fs-10 mt-1">{errors.user_name}</div>
                )}

                <div className='ff-poppins-regular fs-12 mt-2 pt-1'>Phone number<span className="text-danger">*</span></div>
                <input type="tel" className="w-100 ff-poppins-medium fs-20" name="user_mbl" value={formData.user_mbl} onChange={handleChange} />
                {errors.user_mbl && (
                    <div className="text-danger ff-poppins-medium fs-10 mt-1">{errors.user_mbl}</div>
                )}

                <div className='ff-poppins-regular fs-12 mt-2 pt-1'>Email <span className="text-danger">*</span></div>
                <input type="email" className="w-100 ff-poppins-medium fs-20" name="user_email"
                    maxLength={45}
                    value={formData.user_email}
                    onChange={handleChange}
                />
                {errors.user_email && (
                    <div className="text-danger ff-poppins-medium fs-10 mt-1">{errors.user_email}</div>
                )}

                <div className='ff-poppins-regular fs-12 mt-2 pt-1'>
                    Password <span className="text-danger">*</span>
                </div>

                <div style={{ position: "relative" }}>
                    <input type={showPassword ? "text" : "password"}
                        className="w-100 ff-poppins-medium fs-20 pe-5" name="password" maxLength={45}
                        value={formData.password} onChange={handleChange} />

                    <span onClick={() => setShowPassword(!showPassword)}
                        style={{ position: "absolute", right: "9px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}  >
                        {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                    </span>
                </div>

                {errors.password && (
                    <div className="text-danger fs-10 mt-1">{errors.password}</div>
                )}


                <div className='ff-poppins-regular fs-12 mt-2 pt-1'>Gender <span className="text-danger">*</span></div>

                <select className="form-select" name="user_gender" value={formData.user_gender} onChange={handleChange} required >
                    <option value="" disabled selected hidden>Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>


                {errors.user_gender && (
                    <div className="text-danger ff-poppins-medium fs-10 mt-1">{errors.user_gender}</div>
                )}
                <div className="borderbootamBalck" onClick={() => setDatePickerModel(true)}>
                    <div className='ff-poppins-regular fs-12 mt-2 pt-1 dobdatepicker'>Date of Birth<span className="text-danger">*</span></div>

                    <div className={`w-100 ff-poppins-medium fs-15 mt-2 mb-2 ${selectedDate ? '' : 'placeholder-style'}`}>
                        {selectedDate ? `${String(selectedDate.getDate()).padStart(2, '0')}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${selectedDate.getFullYear()}` :

                            <div className="d-flex justify-content-between ps-1 align-items-center text-body-tertiary ">
                                Select Date
                                <span className="CalenderIcon">
                                    <SlCalender />
                                </span>

                            </div>
                        }
                    </div>
                </div>
                {errors.user_dob && (
                    <div className="text-danger ff-poppins-medium fs-10 mt-1">{errors.user_dob}</div>
                )}

                <div className='ff-poppins-regular fs-12 mt-2 pt-1'>Referral Id</div>
                <input type="text" className="w-100 ff-poppins-medium fs-20" name="referral_id" minLength={8} maxLength={8} value={formData.referral_id} onChange={handleChange} />
                <p className="fs-9 ff-poppins-medium primary-text mt-1">Referral ID must contain 4 letters followed by 4 digits (e.g.,ABCD1234).</p>

                <div className="d-flex justify-content-center ">
                    <button disabled={checkBtnDisable()} type="submit"
                        className={`${isLoading ? "loading" : ""} ${checkBtnDisable() ? "opacity-40" : ""} w-100 border-0 primary-bg rounded-pill 
                    ff-poppins-semiBold fs-18 text-white mt-4 mb-2 d-flex justify-content-center align-items-center`}>
                        {
                            isLoading
                                ?
                                <span className="loader-style-1"></span>
                                :
                                <span>Continue</span>
                        }
                    </button>
                </div>
                <div className="text-center fs-12 ff-poppins-medium mb-5">
                    <Link to={"https://pingle.in/user/refund-policy.php"} className="text-decoration-none" >
                        <span className="text-dark"> By registering, you agree to our    </span><br />
                        <span className="primary-text">Terms of Service  </span>
                        <span className="text-dark">   and  </span> {" "}
                        <span className="primary-text">Privacy Policy.</span><br />
                    </Link>
                    <span className="mt-2" onClick={() => tabtoggle("Login")}>
                        Already have an account? {" "} <span className="primary-text">Login</span>
                    </span>
                </div>
                {/* <div className="text-center fs-12 ff-poppins-medium mt-2"  onClick={() => navigate('/login', { state: { tabName: "Register" } })}> */}
            </form>
            {datePickerModel && (
                <DOBPickerModal
                    isOpen={datePickerModel}
                    onClose={() => setDatePickerModel(false)}
                    onSelectDate={handleDateSelect}
                />
            )}
            {isModalOpen && <div className="modal-backdrop fade show" ></div>}

        </>
    )
};

export default UserRegister;

